<div *ngIf="isLoading">
    <ng-container>
        <div class="overlay-layer bg-transparent matspinner">
            <mat-spinner></mat-spinner>
        </div>
    </ng-container>
</div> 

<div *ngIf="!isLoading">
    <div style="height: 10vh; background-color: white; color: #3d3d3d; padding-top: 10px; padding-left: 70px; padding-right: 70px; padding-bottom: 10px;">
        <div class="row">
            <div class="col">
                <!-- <img src="./assets/media/logos/logoShop.png" class="img-fluid" (click)="onReload()"> -->
            </div>
            <div class="col text-right mt-4">
                <!-- MENUBAR -->
            </div>
            <div class="col text-right mt-2">
               
                <div class="row">
                    <div class="col">
                        <mat-form-field appearance="fill">
                            <mat-label>Suche</mat-label>
                            <input type="text" matInput name="search" [(ngModel)]="search" (keydown.enter)="onSearch()">
                            <button matSuffix mat-button (click)="onSearch()"><mat-icon class="matIcon-md-grey">search</mat-icon></button>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

